import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Feed from "@/pages/Feed";
import Discover from "@/pages/Discover";
import Meetups from "@/pages/Meetups";
import Profile from "@/pages/Profile";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Chat from "@/pages/Chat";
import Jobs from "@/pages/Jobs";
import Gurus from "@/pages/Gurus";
import Admin from "@/pages/Admin";
import PostPreview from "@/pages/PostPreview";
import MeetupPreview from "@/pages/MeetupPreview";
import CollegeDirectory from "@/pages/CollegeDirectory";
import PublicJobs from "@/pages/PublicJobs";
import PublicJob from "@/pages/PublicJob";
import PublicScholar from "@/pages/PublicScholar";
import SiteFooter from "@/components/SiteFooter";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/post/:id" element={<PostPreview />} />
            <Route path="/meetup/:id" element={<MeetupPreview />} />
            <Route path="/ayurveda-colleges" element={<CollegeDirectory />} />
            <Route path="/ayurveda-colleges/:stateSlug" element={<CollegeDirectory />} />
            <Route path="/jobs" element={<PublicJobs />} />
            <Route path="/jobs/:id" element={<PublicJob />} />
            <Route path="/scholars/:id" element={<PublicScholar />} />
            <Route path="/app" element={<Protected><Feed /></Protected>} />
            <Route path="/app/discover" element={<Protected><Discover /></Protected>} />
            <Route path="/app/meetups" element={<Protected><Meetups /></Protected>} />
            <Route path="/app/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/app/scholars/:id" element={<Protected><Profile /></Protected>} />
            <Route path="/app/groups" element={<Protected><Groups /></Protected>} />
            <Route path="/app/groups/college/:college" element={<Protected><GroupDetail kind="college" /></Protected>} />
            <Route path="/app/groups/batch/:year" element={<Protected><GroupDetail kind="batch" /></Protected>} />
            <Route path="/app/chat" element={<Protected><Chat /></Protected>} />
            <Route path="/app/chat/:convId" element={<Protected><Chat /></Protected>} />
            <Route path="/app/jobs" element={<Protected><Jobs /></Protected>} />
            <Route path="/app/gurus" element={<Protected><Gurus /></Protected>} />
            <Route path="/app/admin" element={<Protected><Admin /></Protected>} />
          </Routes>
          <SiteFooter />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
